import { createActions } from 'redux-actions';
import { UPDATE_TOKEN } from '../actionTypes';

export default createActions({
  [UPDATE_TOKEN]: (state) => {
    return state;
  }
});
